import React from 'react';

const Outcomes = () => {
  const outcomesData = [
    {
      title: "Fulfilling Children's Potential",
      description: [
        "In our technological world, we aim to help children utilize their unique skills in society. We provide opportunities that were previously unavailable to them.",
        "Through specialized programs, we help each child discover and develop their talents and interests."
      ]
    },
    {
      title: "Healthy Development",
      description: [
        "We focus on psychological health and cognitive development. Our holistic approach ensures children develop essential life skills.",
        "Children learn practical skills like cleaning, cooking, and sewing that build confidence and independence."
      ]
    },
    {
      title: "Empowering Careers",
      description: [
        "We prepare children for meaningful participation in society. Our vocational training programs develop marketable skills.",
        "Children grow to become designers, athletes, teachers, and valued members of their communities."
      ]
    }
  ];

  return (
    <section id="outcomes" className="outcomes">
      <div className="container">
        <h2 className="section-title">Desired Outcomes</h2>
        <div className="outcomes-content">
          {outcomesData.map((outcome, index) => (
            <div key={index} className="outcome-box">
              <h3>{outcome.title}</h3>
              {outcome.description.map((paragraph, pIndex) => (
                <p key={pIndex}>{paragraph}</p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Outcomes;